<template>
    <div :class="['m-agenda-item', {'m-agenda-item-bg-reverse': index % 2 == 0}]">

        <div class="item-wrap" :class="{'item-wrap-small': data.speaker.length == 0}">
            <div class="agenda-title">
                <div class="t-name">
                    <div>{{ data.time.split('~')[0] }}</div>
                    <div>~</div>
                    <div>{{ data.time.split('~')[1] }}</div>
                </div>
            </div>
            <div class="a-content">
                <div class="a-content-wrap">
                    <div class="top">
                        <p class="subject-type">{{ data.subject.split('|')[0] }}</p> <br>
                        <p class="subject-title">{{ data.subject.split('|')[1] }}</p>
                    </div>
                    <div class="bottom">
                        <div class="name-title" v-if="data.speaker[0] && data.speaker[0].photo">
                            <div class="photo"><img :src="data.speaker[0].photo" ></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider-line" v-if="false"> </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["data", "index"]
};
</script>

<style lang="scss">
@media screen and (min-width: 280px) {
  html {
    font-size: 74.6px;
  }
}
@media screen and (min-width: 320px) {
  html {
    font-size: 85.33px;
  }
}
@media screen and (min-width: 360px) {
  html {
    font-size: 96px;
  }
}
@media screen and (min-width: 375px) {
  html {
    font-size: 100px;
  }
}
@media screen and (min-width: 414px) {
  html {
    font-size: 110.4px;
  }
}
@media screen and (min-width: 440px) {
  html {
    font-size: 117.33px;
  }
}
@media screen and (min-width: 480px) {
  html {
    font-size: 128px;
  }
}
@media screen and (min-width: 520px) {
  html {
    font-size: 138.66px;
  }
}
@media screen and (min-width: 540px) {
  html {
    font-size: 144px;
  }
}
@media screen and (min-width: 600px) {
  html {
    font-size: 160px;
  }
}
@media screen and (min-width: 768px) {
  html {
    font-size: 208.4px;
  }
}

.m-agenda-item {
  color: #fff;
  vertical-align: top;
  .item-wrap {
    min-width: 3.6rem;
    text-align: center;
    .agenda-title {
      margin-right: -0.4rem;
      border: 0.05rem solid #808080;
      border-right: none;
      vertical-align: top;
      display: inline-block;
      height: 2rem;
      width: 1rem;
      .t-name {
        color: #fff;
        display: block;
        margin-top: 0.8rem;
        margin-left: 0.06rem;
        width: 0.4rem;
        text-align: center;
        line-height: 16px;
        font-size: 0.16rem;
      }
    }
    .a-content {
      width: 2.9rem;
      display: inline-block;
      background: url("../assets/e-wap/agenda-bg2.png");
      background-size: 100%;
      background-repeat: no-repeat;
      .top {
        height: 1.15rem;
        padding: 0 0.2rem;
        text-align: left;
        .subject-type {
          display: inline-block;
          margin-right: 10px;
          margin-top: 20px;
          font-size: 0.16rem;
        }
        .subject-title {
          margin-top: 8px;
          font-size: 0.18rem;
        }
      }
      .bottom {
        //border: 1px solid greenyellow;
        height: .85rem;
            .name-title {
              .photo {
                text-align: center;
                overflow: hidden;
                img {
                  //border: 1px solid green;
                  display: block;
                  height: .85rem;
                  overflow: hidden;
                }
              }
              .name {
                display: inline-block;
                padding-top: 2px;
                font-size: 20px;
                margin-right: 10px;
              }
              .position {
                display: inline-block;
                font-size: 20px;
                padding-top: 7px;
              }
            }
      }
    }
    .divider-line {
      margin-top: 8px;
      width: 100%;
      border-bottom: 1px solid rgba(236, 28, 36, 0.3);
    }
  }
  .item-wrap-small {
        .agenda-title {
            height: 1.09rem;
            .t-name {
                margin-top: 0.28rem;
            }
        }
      .a-content {
        background: url("../assets/e-wap/agenda-bg1.png");
        background-repeat: no-repeat;
        background-size: 100%;
        height: 1.1rem;
        .top {
            height: 1.1rem;
            padding:  0.1rem 0.2rem;
            text-align: left;
            .subject-type {
                display: inline-block;
                margin-right: 10px;
                margin-top: .05rem;
                font-size: 0.16rem;
            }
            .subject-title {
                margin-top: 8px;
                font-size: 0.18rem;
            }
        }
        .bottom {
            display: none;
        }
      }
    }
  .one-width {
    max-width: 99%;
  }
  .double-width {
  }
  .triple-width {
  }
  .triple-height {
  }
  &:nth-child(2n) {
    margin-right: 0;
  }
}
.m-agenda-item-bg-reverse {
  .a-content-wrap {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
  }
  .a-content {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// MobileAgendaItem.vue?39c5fe87